import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import sample from 'lodash/sample';
import Color from 'color';
import { showSignup } from '../../actions/user';
import { setChosenPlan } from '../../actions/plan';
import { buildGlobalSearchParams, search } from '../../actions/plan';
import { getLatestScenes } from '../../actions/search';
import { setColors } from '../../actions/ui';
import { MARKETING_NAV_LINKS, RESPONSIVE_SIZE } from '../../constants';
import { imageColors, textColor, themeColors } from '../../lib/Color';
import { compose } from '../../lib/react';
import Header from '../../components/Header';
import { withFooterDrawer } from '../../components/Footer';
import Section from '../../components/Section';
import Button from '../../components/Button';
import Link from '../../components/Link';
import ImageLoader from '../../components/ImageLoader';
import NewsletterForm from '../../components/NewsletterForm';
import Toggle from '../../components/Toggle';
import InstagramGrid from '../../components/InstagramGrid';
import PricingStrip from '../../components/PricingStrip';
import Video from '../../components/Video';
import SectionHomeTop from '../../components/SectionHomeTop';
import SubscriptionPlans from '../../components/SubscriptionPlans';
import Style from '../../components/Style';
import {
  L1,
  L2,
  L3,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  P1,
  P2,
} from '../../components/Typography';

import fourKVideo1920 from '../../assets/4k-1920.mp4';
import fourKVideo1280 from '../../assets/4k-1280.mp4';
import fourKVideo640 from '../../assets/4k-640.mp4';
import fourKPoster from '../../assets/4k.jpg';

import Testimonials from '../../assets/testimonials.json';
import PosterScenes from '../../assets/homepage_scenes.json';

class Home extends React.PureComponent {
  static propTypes = {
    responsive: PropTypes.number,
    plan: PropTypes.object,
    onSelectPlan: PropTypes.func,
    onSetAnnual: PropTypes.func,
    onShowSignup: PropTypes.func,
    updateColors: PropTypes.func,
    getLatestScenes: PropTypes.func,
    marketingVanityAnimation: PropTypes.bool,
  };
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      testimonial: sample(Testimonials),
      posterClip: undefined,
      colors: {},
    };
  }

  componentWillMount() {
    this.props.getLatestScenes().then(scenes => {
      let clip = sample(sample(scenes));
      let colors = themeColors(clip.scene_colors);
      this.setState({
        posterClip: clip,
        colors: colors,
      });
      this.props.updateColors(colors);
    });
  }

  render() {
    let corporateMaxWidth = 30;

    let fourKWidth = '177.7777778%';
    let fourKPadding = 2.5;

    let newClipsPadding = `7rem ${fourKPadding}rem 15rem`;
    let instagramOpacity = 0.2;
    let instagramWidth = 100;
    let instagramOffsetX = 15;
    let instagramOffsetY = 3;

    let testimonialWidth = 90;

    let fourKVideo = fourKVideo640;

    if (this.props.responsive >= RESPONSIVE_SIZE.PHONE) {
      fourKWidth = '100%';
      fourKPadding = 5;
      newClipsPadding = `7rem ${fourKPadding}rem 15rem`;
      testimonialWidth = 80;
    }
    if (this.props.responsive >= RESPONSIVE_SIZE.TABLET_PORTRAIT) {
      fourKVideo = fourKVideo1280;
      corporateMaxWidth = 50;
      testimonialWidth = 60;
    }
    if (this.props.responsive >= RESPONSIVE_SIZE.TABLET_LANDSCAPE) {
      fourKVideo = fourKVideo1920;
      newClipsPadding = '12rem 12rem 19rem';
      instagramOpacity = 1;
      instagramWidth = 50;
      instagramOffsetX = 10;
      instagramOffsetY = 5;
      testimonialWidth = 50;
    }

    return (
      <div>
        <div>
          <SectionHomeTop posterClip={this.state.posterClip} />
        </div>

        {this.props.marketingVanityAnimation && (
          <div>
            <Section
              topAngle={17}
              backgroundColor={Style.Colors.white}
              style={{ position: 'relative', zIndex: 3 }}
            >
              <H4
                style={{
                  padding: 'calc(14rem - 10vw) 0 14rem',
                  maxWidth: `${corporateMaxWidth}rem`,
                  margin: 'auto',
                  textAlign: 'center',
                }}
              >
                No more lifeless, corporate stock. Storytape is
                radically&nbsp;different.
              </H4>
            </Section>

            <Section
              style={{
                position: 'relative',
                lineHeight: 0,
                backgroundColor: Style.Colors.black,
              }}
            >
              <Video
                src={fourKVideo}
                poster={fourKPoster}
                style={{ minWidth: '100%', width: fourKWidth }}
              />
              {/*
            TODO: Multiple sources and take the width of the browser into account.
            Netflix:
              4K is ~9Mbps
              1080P is 5Mbps
              720P is 2.5Mbps
             */}
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  textAlign: 'right',
                  color: Style.Colors.white,
                  paddingRight: `${fourKPadding}rem`,
                }}
              >
                <H1 style={{ lineHeight: '0.9em' }}>
                  Storytape<br />is beautifully<br />cinematic 4K.
                </H1>
              </div>
            </Section>

            <Section
              backgroundColor={'rgba(137,130,121,0.42)'}
              contentStyle={{ padding: newClipsPadding }}
            >
              <div>
                <H2>500+ New Clips Every&nbsp;Month.</H2>
                <H6
                  style={{
                    color: '#53503C',
                    maxWidth: '45rem',
                    marginTop: '2.4rem',
                  }}
                >
                  All shot in incredible, ultra-high definition 4K. Available in
                  a variety of different&nbsp;formats.
                </H6>
                <Link to="/how-it-works">
                  <Button style={{ marginTop: '4.1rem' }} arrow={true}>
                    See how it works
                  </Button>
                </Link>
              </div>
            </Section>

            <Section
              style={{ position: 'relative', zIndex: 2 }}
              angle={14}
              backgroundColor={Style.Colors.white}
              contentStyle={{ padding: '6rem 3rem', textAlign: 'center' }}
            >
              <H3 style={{ maxWidth: '16em', margin: 'auto' }}>
                Storytape is&nbsp;remarkably affordable. Less than the cost of 1
                clip on the big&nbsp;sites.
              </H3>
              <P1
                style={{
                  paddingTop: '1.5rem',
                  maxWidth: '31em',
                  margin: 'auto',
                }}
              >
                While others charge you $200 - $500 for a single clip,
                we&nbsp;give&nbsp;you&nbsp;unlimited access to our entire 4K
                library for one low price.
              </P1>

              <div style={{ margin: '6rem auto 2rem' }}>
                <span
                  style={{
                    display: 'inline-block',
                    minWidth: '12rem',
                    textAlign: 'left',
                  }}
                >
                  Paying {this.props.plan.annual ? 'Annually' : 'Monthly'}
                </span>{' '}
                <Toggle
                  checked={this.props.plan.annual}
                  onToggle={this.props.onSetAnnual}
                  style={{ display: 'inline-block' }}
                />
              </div>

              {/* TODO: Scale the plans when at desktop or larger resolutions. */}
              <div
                style={{
                  maxWidth: '110rem',
                  maxWidth: '75rem',
                  margin: 'auto',
                }}
              >
                <SubscriptionPlans
                  plan={this.props.plan}
                  onSelectPlan={this.props.onSelectPlan}
                  bannerColor={this.state.colors.highlight}
                />
              </div>
            </Section>

            <Section
              topAngle={14}
              style={{ position: 'relative', zIndex: 1 }}
              backgroundColor={Style.Colors.shadow2}
            >
              <div>
                <div
                  style={{
                    position: 'relative',
                    zIndex: 1,
                    padding: newClipsPadding,
                    width: `${instagramWidth}%`,
                    color: Style.Colors.white,
                  }}
                >
                  <div style={{ maxWidth: '40rem' }}>
                    <H3>Join our community on&nbsp;Instagram</H3>
                    <P1 style={{ marginTop: '1.5rem' }}>
                      Get a behind the scenes look at where we’re shooting, and
                      find out when we’re on location near&nbsp;you!
                    </P1>
                    <Link to="https://www.instagram.com/storytape/">
                      <Button
                        style={{ marginTop: '3.5rem' }}
                        arrow={true}
                        baseColor={Style.Colors.shadow2}
                      >
                        Open in Instagram
                      </Button>
                    </Link>
                  </div>
                </div>
                <div
                  style={{
                    position: 'absolute',
                    zIndex: 0,
                    opacity: instagramOpacity,
                    right: `-${instagramOffsetX}%`,
                    bottom: `-${instagramOffsetY}%`,
                    width: `${instagramWidth + instagramOffsetX}%`,
                    minWidth: '45rem',
                  }}
                >
                  <InstagramGrid
                    overlayColor={Color(Style.Colors.shadow2)
                      .alpha(0.8)
                      .string()}
                  />
                </div>
              </div>
            </Section>

            <Section
              backgroundColor={Style.Colors.white}
              style={{
                position: 'relative',
                zIndex: 2,
                textAlign: 'center',
              }}
              contentStyle={{ padding: '10rem 2rem 19vw' }}
            >
              <H4 style={{ maxWidth: '56rem', margin: 'auto' }}>
                Not on social? Want the latest happenings delivered right to
                your&nbsp;inbox?
              </H4>
              <NewsletterForm />
            </Section>

            <Section
              style={{
                position: 'relative',
                zIndex: 3,
              }}
              topAngle={14}
              backgroundColor={this.state.colors.light}
            >
              <div style={{ display: 'flex', paddingBottom: '10vw' }}>
                <div
                  style={{
                    flex: `1 1 ${100 - testimonialWidth}%`,
                    width: `${100 - testimonialWidth}%`,
                    backgroundColor: this.state.colors.dark,
                    transformOrigin: '100% 100%',
                    transform: 'skewY(14deg)',
                  }}
                />
                <div
                  style={{
                    flex: `1 1 ${testimonialWidth}%`,
                    width: `${testimonialWidth}%`,
                    padding: '5.5vw 7% 6vw 4rem',
                  }}
                >
                  <div style={{ maxWidth: '50rem' }}>
                    <H3>{`“${this.state.testimonial.hook}`}</H3>
                    <P1 style={{ margin: '1.4rem 0' }}>
                      {`${this.state.testimonial.more}”`}
                    </P1>
                    <L1 style={{ margin: '2rem 0' }}>{`— ${this.state
                      .testimonial.author}`}</L1>
                  </div>
                </div>
              </div>
            </Section>

            <Section>
              <PricingStrip />
            </Section>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    responsive: state.runtime.responsive,
    plan: state.plan.chosenPlan,
    layoutLoading: state.runtime.layoutLoading,
    layoutLoaded: state.runtime.layoutLoaded,
    marketingVanityAnimation: state.runtime.marketingVanityAnimation,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSelectPlan: planName =>
      dispatch(setChosenPlan({ name: planName })).then(() =>
        setTimeout(dispatch, 500, showSignup()),
      ),
    onSetAnnual: annual => dispatch(setChosenPlan({ annual: annual })),
    updateColors: colors => dispatch(setColors(colors)),
    onShowSignup: () => dispatch(showSignup()),
    getLatestScenes: () => dispatch(getLatestScenes()),
  };
}

export default compose(
  withFooterDrawer(),
  connect(mapStateToProps, mapDispatchToProps),
)(Home);



// WEBPACK FOOTER //
// ./src/routes/home/Home.js